import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { useThemeColors } from '@/styles';

export function OfflineBanner() {
  const isOnline = useNetworkStatus();
  const colors = useThemeColors();

  if (isOnline) return null;

  return (
    <div
      className="w-full px-4 py-2 text-center text-sm font-medium border-b"
      style={{
        backgroundColor: colors.warning.background,
        borderColor: colors.warning.border,
        color: colors.warning.text,
      }}
    >
      You're offline. Changes won't be saved.
    </div>
  );
}
